














































































import { Component, Vue } from "vue-property-decorator";
// require styles
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

const YOUPAI = "https://appd.knowbox.cn/ss/activity/knowbox-web/img/";

@Component({
    components: {
        swiper,
        swiperSlide
    }
})
export default class About extends Vue {
    public $refs!: {
        swiper: any;
    };
    private swiperOption: any = {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    };
    private timeLineData: any = [
        `${YOUPAI}about/timeline-1@x2.png`,
        `${YOUPAI}about/timeline-2@x2.png`,
        `${YOUPAI}about/timeline-3@x2.png`,
        `${YOUPAI}about/timeline-4@x2.png`,
        `${YOUPAI}about/timeline-5@x2.png`,
        `${YOUPAI}about/timeline-6@x2.png`,
        `${YOUPAI}about/timeline-7@x2.png`,
        `${YOUPAI}about/timeline-8@x2.png`
    ];

    private get swiper() {
        return this.$refs.swiper.swiper;
    }
}
